import styled from "styled-components";
import { Card } from "@mui/material";

export const StyledCard = styled(Card)`
  &.MuiPaper-root {
    border-radius: 0;
    box-shadow: unset;
  }
`;
